import { useEffect, useState } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { useGetCompanyName, useGetCompanyToken } from "../../api/company";
import { usePostUserCognitoLogin, usePostUserDetails } from "../../api/userDetails";
import { notificationSetupService } from "../../config/firebase";
import { errorView } from "../../helpers/ErrorHandler";
import { useAuthContext } from "../../hooks/useAuthContext";
import { setAccessToken } from "../../utils/authTokenStore";
import {
  consumeReturnPath,
  removeTokens,
  saveCompanyTenantId,
  saveTenantId,
  saveUserTenantId
} from "../../utils/cacheStorage";
import { checkAvailableUserCompanyId } from "../../utils/utils";
import "./Login.scss";

const CognitoLogin = () => {
  const auth = useAuth();

  const navigate = useNavigate();
  const [userEmail, setUserEmail] = useState("");
  const { dispatch, setCompany, logout } = useAuthContext();

  const { data: userData, mutate } = usePostUserCognitoLogin();

  const { data: userProfileData, mutate: loadUserData } = usePostUserDetails();

  const { data: company, status } = useGetCompanyName(userProfileData?.tenantId);

  const { mutate: getCompanyToken } = useGetCompanyToken();

  const loadUserDetails = (userData: any) => {
    if (userData?.isPasswordResetRequired) {
      navigate("/password-reset", {
        state: {
          isPasswordResetRequired: userData?.isPasswordResetRequired || false,
          email: userEmail
        }
      });
    } else {
      loadUserData("");
    }
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      setUserEmail(auth.user?.profile?.email || "");
      mutate(
        {
          token: auth.user?.id_token
        },
        {
          onSuccess: data => {
            setAccessToken(data.token);
            loadUserDetails(data);
          }
        }
      );
    } else if (!auth.isAuthenticated && !auth.isLoading) {
      onLogin();
    } else {
      removeTokens();
      setCompany("", "");
      logout();
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  const loadCompanyDetials = () => {
    let { id, status, name, tenantId } = checkAvailableUserCompanyId(company, userProfileData);
    if (status) {
      getCompanyToken(id, {
        onSuccess: data => {
          saveCompanyToken(data);
        }
      });
      setCompany(name, id);
    } else {
      errorView("User hasn't any company");
      removeTokens();
    }
  };

  const saveCompanyToken = (data: any) => {
    setAccessToken(data?.token || null);
    saveCompanyTenantId(userProfileData?.tenantId || '');
    saveUserTenantId(userProfileData?.tenantId || '');
    requestPermission(userProfileData);
    saveTenantId((userProfileData?.tenantId || null) as string);
    if (userData) {
      if (userData?.isPasswordResetRequired || false) {
        navigate("/password-reset", {
          state: {
            isPasswordResetRequired: userData?.isPasswordResetRequired || false,
            email: userEmail
          }
        });
      } else {
        if (userProfileData && data) {
          dispatch({ type: "LOGIN", payload: userProfileData });
          navigate(consumeReturnPath() ?? "/", {
            state: { isPasswordResetRequired: false, email: userEmail }
          });
        }
      }
    }
  };

  const requestPermission = (userProfileData: any) => {
    notificationSetupService.setup(userProfileData, () => {});
  };

  useEffect(() => {
    if (status == "success") {
      loadCompanyDetials();
    }
  }, [status == "success"]);

  const onLogin = async () => {
    console.log("Redirecting to login...");
    await auth.signinRedirect();
  };

  return (
    <div className="mainContaa">
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    </div>
  );
};
export default CognitoLogin;
